import { QueueTypes } from '@core/enumeration';

/**
 * Mapping the active queue based on the user's group
 */
export default {
  AppealGrievance: QueueTypes.AGQueue,
  DMEPOSMedicaidOperations: QueueTypes.DMEPOS_MCD,
  DMEPOSMedicaidOperationsAdmin: QueueTypes.DMEPOS_MCD,
  DMEPOSMedicareOperations: QueueTypes.DMEPOS_MA,
  DMEPOSMedicareOperationsAdmin: QueueTypes.DMEPOS_MA,
  HHAppealGrievance: QueueTypes.AGQueue,
  HHOperations: QueueTypes.HHQueue,
  HHOperationsAdmin: QueueTypes.HHQueue,
  PACCommercialOperations: QueueTypes.PACCommercialQueue,
  PACOperations: QueueTypes.PACQueue,
  SDoHOperations: QueueTypes.SdohQueue,
  WoundOstomy: QueueTypes.WCCAdmissionsQueue,
};
